// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__3L4uO","commentTextarea":"Footer_commentTextarea__28dmB","buttons":"Footer_buttons__x7F96"};